export const services = [
  {
    id: 1,
    title: 'Limpieza del hogar',
    description: 'Servicio profesional de limpieza para mantener tu hogar impecable',
    icon: 'ri-home-smile-line',
    image: 'https://public.readdy.ai/ai/img_res/70aa010f652af9ff71a9139dc16ed729.jpg'
  },
  {
    id: 2,
    title: 'Cuidado de personas mayores',
    description: 'Atención personalizada y profesional para el cuidado de personas mayores',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=caring%20professional%20caregiver%20in%20turquoise%20uniform%20assisting%20smiling%20elderly%20person%20in%20comfortable%20modern%20home%20setting%20with%20warm%20lighting%20compassionate%20atmosphere%20tropical%20environment&width=400&height=300&seq=service-care-gc&orientation=landscape'
  },
  {
    id: 3,
    title: 'Mantenimiento',
    description: 'Reparaciones y mantenimiento general para tu hogar',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20home%20maintenance%20worker%20in%20turquoise%20uniform%20performing%20repairs%20with%20tools%20in%20modern%20residential%20setting%20clean%20organized%20workspace%20bright%20lighting&width=400&height=300&seq=service-maint-gc&orientation=landscape'
  },
  {
    id: 4,
    title: 'Planchado',
    description: 'Servicio de planchado profesional para tu ropa',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20ironing%20service%20with%20neatly%20pressed%20clothes%20modern%20iron%20in%20bright%20clean%20laundry%20room%20organized%20workspace%20turquoise%20accents%20contemporary%20setting&width=400&height=300&seq=service-iron-gc&orientation=landscape'
  }
];

export const benefits = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: 'Personal verificado',
    description: 'Equipo profesional con formación certificada y referencias comprobadas'
  },
  {
    id: 2,
    icon: 'ri-calendar-check-line',
    title: 'Horarios flexibles',
    description: 'Nos adaptamos a tu disponibilidad y necesidades específicas'
  },
  {
    id: 3,
    icon: 'ri-price-tag-3-line',
    title: 'Tarifas claras',
    description: 'Presupuestos transparentes sin sorpresas ni costes ocultos'
  },
  {
    id: 4,
    icon: 'ri-customer-service-2-line',
    title: 'Atención cercana',
    description: 'Equipo local disponible para resolver tus dudas y necesidades'
  },
  {
    id: 5,
    icon: 'ri-star-smile-line',
    title: 'Calidad asegurada',
    description: 'Garantía de satisfacción en cada servicio que realizamos'
  },
  {
    id: 6,
    icon: 'ri-time-line',
    title: 'Servicio puntual',
    description: 'Cumplimos con los horarios acordados de forma rigurosa'
  }
];

export const stats = [
  {
    id: 1,
    number: '+12.500',
    label: 'Hogares atendidos'
  },
  {
    id: 2,
    number: '+8',
    label: 'Años de experiencia'
  },
  {
    id: 3,
    number: '150+',
    label: 'Profesionales'
  },
  {
    id: 4,
    number: '4.9',
    label: 'Valoración media'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Carmen Suárez',
    location: 'Las Palmas de Gran Canaria',
    rating: 5,
    comment: 'Excelente servicio de limpieza. El equipo es muy profesional y mi casa queda perfecta cada vez. Totalmente recomendable.',
    date: '18 de diciembre, 2024'
  },
  {
    id: 2,
    name: 'Miguel Hernández',
    location: 'Telde',
    rating: 5,
    comment: 'Contraté el servicio de mantenimiento y quedé muy satisfecho. Resolvieron todo de forma rápida y profesional. Muy contentos.',
    date: '12 de diciembre, 2024'
  },
  {
    id: 3,
    name: 'Isabel Pérez',
    location: 'Maspalomas',
    rating: 5,
    comment: 'El cuidado que brindan a mi padre es excepcional. Son muy cariñosos, atentos y profesionales. Los recomiendo sin dudarlo.',
    date: '8 de diciembre, 2024'
  }
];

export const faqs = [
  {
    id: 1,
    question: '¿Cómo puedo solicitar un servicio?',
    answer: 'Puedes solicitar nuestros servicios a través del formulario de contacto en nuestra web, llamando por teléfono o enviándonos un email. Te responderemos en menos de 24 horas con un presupuesto personalizado.'
  },
  {
    id: 2,
    question: '¿Cuál es el horario de atención?',
    answer: 'Nuestro horario de atención es de lunes a sábado de 8:00 a 19:00 horas. Los servicios se pueden programar según tu disponibilidad, incluyendo fines de semana si es necesario.'
  },
  {
    id: 3,
    question: '¿Los profesionales están asegurados?',
    answer: 'Sí, todos nuestros profesionales cuentan con seguro de responsabilidad civil y han pasado por un proceso de verificación y formación exhaustivo.'
  },
  {
    id: 4,
    question: '¿Puedo cancelar o modificar una cita?',
    answer: 'Sí, puedes cancelar o modificar tu cita con al menos 24 horas de antelación sin ningún coste adicional. Solo tienes que contactarnos.'
  },
  {
    id: 5,
    question: '¿Qué zonas de Gran Canaria cubren?',
    answer: 'Ofrecemos servicios en toda la isla de Gran Canaria, incluyendo Las Palmas, Telde, Maspalomas, Agüimes, Arucas, Gáldar y todos los municipios.'
  },
  {
    id: 6,
    question: '¿Cómo se realiza el pago?',
    answer: 'Aceptamos pagos en efectivo, tarjeta de crédito/débito y transferencia bancaria. El pago se realiza una vez finalizado el servicio a tu entera satisfacción.'
  }
];